<template>
  <el-dialog
    v-dialogDrag
    title="设备二维码"
    :visible.sync="visible"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <div
      class="font-bold flex justify-center items-center flex-col px-10px py-10px box-content border-1 border-slate-300"
    >
      <div class="w-450px h-450px" v-loading="imgLoading">
        <el-image v-if="qrCodeContent" class="w-full h-full" :src="qrCodeContent"></el-image>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <div class="flex justify-center">
        <el-button type="primary" size="small" @click="exportPDF" :loading="pdfLoading"
          >导出PDF</el-button
        >
        <el-button type="primary" size="small" @click="exportPNG" :loading="pngLoading"
          >导出PNG</el-button
        >
        <el-button @click="closeDialog" size="small">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { EquipmentFacilityListApi } from '@wiz-api/double-prevention-management'

const equipmentFacilityListApi = new EquipmentFacilityListApi()
export default {
  name: 'qr-code',
  components: {},
  props: {
    // 设备
    equipObj: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      qrCodeContent: '',
      visible: true,
      pdfLoading: false,
      pngLoading: false,
      imgLoading: false,
    }
  },
  mounted() {
    this.getImgContent()
  },
  methods: {
    // 关闭弹窗
    closeDialog() {
      this.$emit('cancel')
    },
    async getImgContent() {
      this.imgLoading = true
      const [err, res] = await equipmentFacilityListApi.gengQrCode({
        type: 0,
        id: this.equipObj.id,
      })
      if (!err) {
        this.qrCodeContent = `data:image/jpg;base64,${res}`
      }
      this.imgLoading = false
    },
    // 导出pdf
    async exportPDF() {
      this.pdfLoading = true
      const [err, res] = await equipmentFacilityListApi.gengQrCode({
        type: 1,
        id: this.equipObj.id,
      })
      if (!err) {
        this.$message({
          showClose: true,
          message: '导出成功',
          type: 'success',
        })
      }
      this.pdfLoading = false
      const fileStream = await this.base64ToBolb(res)
      this.exportFile(fileStream, '设备设施二维码', 1)
    },

    // 导出png
    async exportPNG() {
      this.pngLoading = true
      const [err, res] = await equipmentFacilityListApi.gengQrCode({
        type: 0,
        id: this.equipObj.id,
      })
      if (!err) {
        this.$message({
          showClose: true,
          message: '导出成功',
          type: 'success',
        })
      }
      this.pngLoading = false
      const fileStream = this.base64ToBolb(res)
      this.exportFile(fileStream, '设备设施二维码', 0)
    },
    base64ToBolb(res) {
      const raw = window.atob(res)
      const rawLength = raw.length
      const uInt8Array = new Uint8Array(rawLength)
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
      }
      return new Blob([uInt8Array])
    },
    /**
     * 下载文件
     * @param {*} data base64
     * @param {*} name 文件名
     * @param {*} fileType 文件类型 0 png， 1 pdf
     */
    exportFile(data, name, fileType) {
      const blob = new Blob([data], {
        type: fileType === 0 ? 'image/png' : 'application/pdf',
      })
      const blobUrl = window.URL.createObjectURL(blob)
      const templink = document.createElement('a')
      templink.style.display = 'none'
      templink.href = blobUrl
      templink.setAttribute('download', `${name}`)
      document.body.appendChild(templink)
      templink.click()
      document.body.removeChild(templink)
      window.URL.revokeObjectURL(blobUrl)
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-dialog__body {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
